// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__17r1O","container":"styles_container__5bScJ","title":"styles_title__3HI8S","wrapper":"styles_wrapper__1zviA","answer":"styles_answer__38XPQ"};